<div #splash class="mg-splash" role="status" aria-label="Carregando Mais Gestão">
  <img src="./assets/marca/Mais Gestao - Horizontal_cor.webp" alt="Mais Gestão" />
  <div class="mg-splash__indicador" aria-hidden="true"></div>
</div>
